import { Link } from "@inertiajs/react";

const EXTERNAL_PATTERN = /^(https?:|mailto:|tel:)/;

export default function SmartLink({ href, children, ...props }) {
  if (!href) {
    return <span {...props}>{children}</span>;
  }

  if (EXTERNAL_PATTERN.test(href) || href.includes("#")) {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
}
